import React, { PropsWithChildren } from 'react';
import { NotificationDot } from '@fullstory/components';

export interface UnreadNotificationDotProps {
  unread: boolean;
  offset?: number;
}

export const UnreadNotificationDot: React.FC<PropsWithChildren<UnreadNotificationDotProps>> = ({
  unread,
  offset = 0,
  children,
}) => (
  <NotificationDot
    data-component="UnreadNotificationDot"
    color="brand"
    top={offset - 2}
    right={offset - 2}
    enabled={unread}
  >
    {children}
  </NotificationDot>
);
